import * as React from 'react';
import { resolve } from "inversify-react";
import autobind from "autobind-decorator";

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from "src/core/services/ui/dialog.service";
import { PlaceListView } from "./place-list.view";
import { PlaceListDataService } from "./place-list.data";

export class PlaceListController extends React.Component<ControllerProps<any>, any> {
    protected dataService: PlaceListDataService;

    @resolve
    protected dialogService: DialogService;

    @resolve
    protected toast: ToastNotifications;

    public constructor(props) {
        super(props);
        this.dataService = PlaceListDataService.make();
    }

    public componentDidMount() {
        this.loadData();
    }

    @autobind
    protected onItemDoubleClicked(item: PlaceSummary | 'new', type: string) {
        this.props.history.push(`/general/places/${item == 'new' ? item : item.id}/${type}`);
    }

    @autobind
    protected loadData() {
        this.props.setBusy(true);
        this.dataService.addSorting('id', 'asc', true);
        this.dataService.addFilter('isDeleted', 'eq', false);
        this.dataService.load(query => query)
            .then(() => this.props.setBusy(false))
            .catch(error => {
                this.props.setBusy(false)
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            });
    }

    public render() {
        return (
            <PlaceListView
                model={this.dataService}
                setBusy={this.props.setBusy}
                onItemDoubleClicked={this.onItemDoubleClicked}
                {...this.props}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/places/list/place-list.controller.tsx